import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-water-detail-template',
  templateUrl: './water-detail-template.component.html',
  styleUrls: ['./water-detail-template.component.less']
})
export class WaterDetailTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
